var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-form-group',{attrs:{"label":_vm.label}},[_c('o-file-upload-control',{attrs:{"allow-clear":_vm.allowClear,"allow-download":_vm.allowDownload,"accept":_vm.accept},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }